import { Component, Input, ChangeDetectionStrategy } from "@angular/core";

export type TopBannerVariant = "info" | "warning";

/**
 * Full-width top banner container (system messages, translation warning, etc.).
 * Use variant for background/border; project rows via ng-content.
 */
@Component({
  selector: "app-top-banner-shell",
  standalone: true,
  templateUrl: "./top-banner-shell.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: "./top-banner-shell.component.css",
})
export class TopBannerShellComponent {
  @Input({ required: true }) variant!: TopBannerVariant;
}
